import { render, staticRenderFns } from "./session-management copy.vue?vue&type=template&id=0b6a4de2"
import script from "./session-management copy.vue?vue&type=script&lang=js"
export * from "./session-management copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports